import { useCategoryContext } from "@components/Components/Providers/CategoryContext";
import { count } from "@components/config/helpers";
import useWindowSize from "@components/_hooks/useWindowSize";
import Grid from "@mui/material/GridLegacy";
import dynamic from "next/dynamic";
import { useCallback, useMemo, useRef } from "react";
import ProductExtrasDialogHost from "./ProductExtrasDialogHost";
const CategoryProductTile = dynamic(() => import("./CategoryProductTile"));
const CategorySkeletonTiles = dynamic(() => import("./CategorySkeletonTiles"), {
    ssr: false
});


const CategoryProducts = ({ loadingProducts, template_page_settings, long_term, source }) => {
    const {
        categoryProducts: products,
        catData: props
    } = useCategoryContext();

    const { isMobile } = useWindowSize();
    // The options dialog keeps its own state (see ProductExtrasDialogHost), so opening it does not draw the tiles again. The tiles are
    // given only a function that opens it, which never changes.
    const extrasDialog = useRef(null);
    const openExtras = useCallback((extrasData) => extrasDialog.current?.open(extrasData), []);
    const extrasHook = useMemo(() => ({ openExtras }), [openExtras]);

    if (loadingProducts) return (<CategorySkeletonTiles template_page_settings={template_page_settings} />)

    return (
        <>
            <ProductExtrasDialogHost ref={extrasDialog} />

            <Grid container className={`${isMobile && "pl-2 pr-2"} mt-0 mb-5`} spacing={isMobile ? 1 : 2} sx={{ transition: 'all 0.5s ease' }} rowSpacing={{ sm: 12, lg: 2, md: 2 }}>
                {products &&
                    count(products) != 0 &&
                    products.map((product, idx) => (
                        <CategoryProductTile
                            key={idx}
                            long_term={long_term}
                            props={props}
                            product_idx={idx}
                            product={product}
                            source={source}
                            show_images={false}
                            extrasHook={extrasHook}
                            gridProps={{
                                xl: 3,
                                lg: 3,
                                md: 3,
                                sm: 6,
                                xs: 6,
                            }}
                        />
                    )
                    )}
            </Grid>
        </>

    )
}

export default CategoryProducts